import { render, staticRenderFns } from "./FcfList.vue?vue&type=template&id=4fbf999e&"
import script from "./FcfList.vue?vue&type=script&lang=js&"
export * from "./FcfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports